<template>
  <div class="app-main-content">
    <div class="details-view">
      <div style="height: 100%">
        <div style="display: flex;flex-wrap: nowrap;height: 100%;">
          <div class="section" style="width: 25%; background-color: #ffffff">
            <div style="">
              <span
                style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
              >{{ '.' }}</span>
              <div style="padding-left: 10px;padding-bottom: 15px"> {{ $t('CargoMsg.Cargo_TransmissionRule') }}</div>
            </div>
            <div style="height: 50%;">
              <el-form
                label-position="left"
                label-width="0px"
                style="height: 100%"
              >
                <el-form-item label=" " style="height: 100%" class="input-from">
                  <el-input
                    v-model="ruleData"
                    class="input-border"
                    :filter-chars="false"
                    type="textarea"
                    :readonly="true"
                    clearable
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="section" style="width: 35%;background-color: #ffffff">
            <div style="display: flex;justify-content: space-between;">
              <div>
                <span
                  style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
                >{{ '.' }}</span>
                <div style="padding-left: 10px;padding-bottom: 5px"> {{ $t('CargoMsg.Cargo_Script') }} </div>
              </div>
              <div style="padding: 1px">
                <el-button type="success" @click="deBugHandler">{{ $t('CargoMsg.Cargo_DebuggingResults') }}</el-button>
              </div>
            </div>
            <div style="display: flex;height: 100%;">
              <div style="height: 100%;width: 100%">
                <el-form
                  label-position="left"
                  label-width="0px"
                  style="height: 100%"
                >
                  <el-form-item label=" " style="height: 100%" class="input-from">
                    <el-input
                      v-model="nbParams.dataScript"
                      class="input-border"
                      :filter-chars="false"
                      type="textarea"
                      clearable
                    />
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <show-message-dialog
      v-if="showMessage.visible"
      :visible.sync="showMessage.visible"
      :message-text="showMessage.messageText"
    />
  </div>
</template>

<script>

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import showMessageDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/showMessageDialog.vue'
import { pushThirdPartyDataDeBugFunc } from '@/api/sysAutoConfig/sysAutoTask'

export default {
  name: 'ThirdPartySendSettings',
  components: { showMessageDialog },
  props: {
    taskScenario: { type: String, required: true }
  },
  data() {
    return {
      SystemConstants,
      querySql: '',
      showMessage: {
        visible: false,
        messageText: ''
      },
      nbParams: {
        accountId: '',
        passWord: '',
        id: '',
        tokenUrl: '',
        interfaceUrl: '',
        action: '',
        dataScript: ''
      },
      dataMessage: ''
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh'
    },
    isPlatform() {
      return this.$store.getters.isPlatform
    },
    ruleData() {
      if (this.taskScenario === SystemConstants.TASK_SCENARIO_6.code) {
        return '应收时，wageinout传输true,\n' + '应付时，wageinout传输false'
      }
    }
  },
  beforeMount() {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
  },
  methods: {
    async onShow(action, from, task) {
      await this.clearParams()
      if (task) {
        if (task.propertiesData && Object.keys(task.propertiesData).length) {
          this.loadProperties(task.propertiesData)
        }
        this.querySql = task.dataScript
      }
    },
    async clearParams() {
      this.nbParams.accountId = ''
      this.nbParams.passWord = ''
      this.nbParams.id = ''
      this.nbParams.tokenUrl = ''
      this.nbParams.interfaceUrl = ''
      this.nbParams.action = ''
      this.nbParams.dataScript = ''
    },
    loadProperties(item) {
      this.nbParams.accountId = item.accountId
      this.nbParams.passWord = item.passWord
      this.nbParams.id = item.id
      this.nbParams.tokenUrl = item.tokenUrl
      this.nbParams.interfaceUrl = item.interfaceUrl
      this.nbParams.action = item.action
      this.nbParams.dataScript = item.dataScript
    },
    deBugHandler() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyStr: this.querySql,
        anyStr1: this.nbParams.dataScript,
        anyStr2: this.taskScenario
      }
      pushThirdPartyDataDeBugFunc(params).then(res => {
        this.showMessage.messageText = res.data
        this.showMessage.visible = true
      })
    },
    endTabHandler() {
      this.$emit('ruleSettingChange', { ... this.nbParams })
    },
    toNext() {
      this.$emit('ruleSettingChange', { ... this.nbParams })
    }
  }
}
</script>
<style lang="scss">
.app-main-content {

  .input-from {
    .el-form-item__content {
      width: 100%;
      height: 100%;
    }
  }

  .input-border {
    height: 100%;

    .el-textarea__inner {
      width: 100%;
      height: 100%;
    }
  }

  .general-pagination {
    .el-pager {
      li.number.active {
        color: blue !important;
      }
    }
  }
}
</style>
